var React = require('react');

function Sort (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"sort-up","d":"M1 11L5.21053 15L9 11","stroke":"#909090","strokeWidth":"2","key":0}),React.createElement("path",{"className":"sort-down","d":"M9 6L4.78947 2L1 6","stroke":"#909090","strokeWidth":"2","key":1})]);
}

Sort.defaultProps = {"viewBox":"0 0 10 17","fill":"none"};

module.exports = Sort;

Sort.default = Sort;
